/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../../../../../CommonMethods/OutsideClick';
import FilterDeviceAlert from '../Filter';
import CustomDatePicker from '../../../../../../../components/DatePicker';
import { convertDatesToEpochUTC } from '../../../../../../../CommonMethods/ConvertFilterDatetoEpochUtcFormat';
import dayjs from 'dayjs';
import moment from 'moment';
import DeviceAlertListExport from '../Export';
import GlobalContext from '../../../../../../../components/Context/GloablContext';
import { handleSidebarPrvState } from '../../../../../../../redux/systemConfigSlice';


const TopBarDeviceAlert = ({
    title,
    ApplyFilter,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    data,
    exportDeviceAlertList,
    isIdexport,
    selectedOrganizationName,
    setSelectedOrganizationName,
    setSubDivisionDataLoading,
    userArr,
    subDivisionDataLoading,
    TotalCount
}) => {
   
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isChangeStatusOPenxl, setIsChangeStatusOpenxl] = useState(false)
    const [dateError, setdateError] = useState(false)
    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const {setIsSearchOpen, isSearchOpen, setIsSideBar,isSideBar} = useContext(GlobalContext);
    const ref = useRef()
    const ref2 = useRef()
    const dispatch =useDispatch()
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })

    const handleCheck=(start_date,end_date)=>{
        if((dayjs(end_date).isBefore(dayjs(start_date)))&&(end_date!==undefined&&start_date!==undefined)){
            return true
        }
        return false
    }

    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    useOnClickOutside(ref2, () => {
        setIsChangeStatusOpenxl(false)
    })

    const handleOpenFilter = () => {
        setdateError(false)
        // setFilterValues(resultArray)
        // dispatch(handleAddFilterValues(resultArray))
        setIsFilterOpen(!isFilterOpen)
    }

    function handleSelectDate(id,date,dateString,termkey){
        isFilterOpen&&setIsFilterOpen(false)
        if(id==="filter_end_date"&&filterValues?.start_date!==undefined&&handleCheck(filterValues?.start_date,dateString)){
            setdateError(true)
            return
        }
        if(id==="filter_start_date"&&filterValues?.end_date!==undefined&&handleCheck(dateString,filterValues?.end_date)){
            setdateError(true)
            return
        }
        setdateError(false)
        let params = Object.fromEntries(searchParams)
        params.page_number = 1
        params.last_page = null
        params.last_id = null
        params.last_sort_value = null
        if(id==="filter_start_date"){
            setFilterValues((prv) => ({
                ...prv,
                start_date: dateString,
            }));
            
            params.start_date =moment(dateString).format('YYYY-MM-DD')
            setSearchParams({...params})
        }
        else{
            setFilterValues((prv) => ({
                ...prv,
                end_date: dateString,
            }));
            params.end_date= moment(dateString).format('YYYY-MM-DD')
            setSearchParams({...params})
        }
    }

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
      
        // Update the states after storing the previous state
        setIsSearchOpen(true);
        setIsSideBar(false);
    };
    
    return (
        <div className="flex justify-between items-center mb-[18px]">
            <div>
                <h1 className="text-xl font-normal text-[#000000] min-w-max mr-4">{title}</h1>
            </div>
            <div className="flex items-center w-full justify-end relative 2xl:flex-nowrap flex-wrap">
                
                <div className='flex items-center relative'>
                    <span className='absolute top-[38px] left-0'>
                        {dateError &&<p className="text-xs text-red-500 mt-2">Please select the valid date range.</p>}
                    </span>
                    <div className='w-full mr-2'>
                        <CustomDatePicker 
                            id={"filter_start_date"}
                            classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                            format="MMM DD, YYYY"
                            state={filterValues}
                            data-testid={"start_date"}
                            placeholder={"Select start date"}
                            termkey={filterValues?.start_date}
                            handleSelect={handleSelectDate}
                            imageClass={true}
                            setdateError={setdateError}
                        />
                    </div>
                    <div className='w-full '>
                        <div className='w-full'>
                            <CustomDatePicker
                                classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                placeholder={"Select end date"}
                                format="MMM DD, YYYY"
                                state={filterValues}
                                termkey={filterValues?.end_date}
                                handleSelect={handleSelectDate}
                                id={"filter_end_date"}
                                setdateError={setdateError}
                            />
                        </div>
                    </div>
                    <button id='search-btn' 
                        onClick={handleSearchClick} 
                        className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[11px] py-[11px] min-w-max">
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon"/>
                    </button>
                    {(ApplyFilter !== undefined && ApplyFilter) &&
                        <FilterDeviceAlert
                            dateError={dateError}
                            setdateError={setdateError}
                            isFilterOpen={isFilterOpen}
                            setIsFilterOpen={setIsFilterOpen}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            initialState={initialState}
                            handleOpenFilter={handleOpenFilter}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setSubDivisionDataLoading={setSubDivisionDataLoading}
                            subDivisionDataLoading={subDivisionDataLoading}
                            userArr={userArr}
                        />
                    }
                    
                    {data?.data?.length>0&&<div>  <DeviceAlertListExport
                        selectedRows={selectedRows}
                        exportDeviceAlertList={exportDeviceAlertList}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        isIdexport={isIdexport} 
                        username={username} 
                        TotalCount={TotalCount}    
                    />
                    </div> }
                </div>
            </div>
        </div>
    );
}

export default TopBarDeviceAlert;
